import {memo} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';
import Icon from 'components/Icon';

interface IArticleViewsProps {
    count: number;
}

const ArticleViews = memo<IArticleViewsProps>(function ({count}) {
    return (
        <div className={style.articleViews}>
            <Icon className={style.icon} icon={'eye'} />
            <Typography variant={'label-14-r-fluid'}> {count || 0}</Typography>
        </div>
    );
});

export default ArticleViews;
